module.exports = __webpack_public_path__ + "img/visa_electron_logo.dcdbe333.svg";